import React from 'react'
import PropTypes from 'prop-types'
import { Card, Heading3 } from '@sainsburys-tech/luna-react'

import StorePsa from 'src/modules/StorePsa'
import StoreSearch from 'src/modules/StoreSearch'

const Component = ({ params: { id, businessUnit, storeId }, location }) => (
  <Card>
    {!storeId ? (
      <div>
        <Heading3>Store search</Heading3>
        <StoreSearch route={`cycles/${businessUnit}/${id}/store-psa`} />
      </div>
    ) : (
      <>
        <StorePsa
          cycleId={id}
          storeId={storeId}
          businessUnit={businessUnit}
          location={location}
          storePSAFlag
        />
      </>
    )}
  </Card>
)

Component.propTypes = {
  params: PropTypes.shape({
    id: PropTypes.string.isRequired,
    businessUnit: PropTypes.string.isRequired,
    storeId: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    id: PropTypes.string.isRequired,
    businessUnit: PropTypes.string.isRequired,
  }).isRequired,
}
export default Component
